<template>
  <!-- {{ jobDetail.consumer }} -->
  <!-- Figma S&R Details (5504:1281) "Consumer Details": title left, 50px avatar + name, then View Members / call / message -->
  <div v-if="jobDetail.consumer"
    class="consumerDetail shadow-[0px_0px_10px_0px_#0000001A] rounded-[20px] px-[15px] laptop:px-[20px] py-[20px] bg-white font-roboto">
    <div class="flex items-center gap-1 pb-[15px]">
      <div class="w-[8px] h-[8px] rounded-full bg-[#A084E8]" />
      <div class="w-[35px] h-[8px] rounded-full bg-[#A084E8]" />
      <p class="text-[18px] laptop:text-[20px] font-semibold pl-2 m-0 text-[#333333]">
        {{ showConsumer ? 'Consumer Details' : 'Resident Details' }}
      </p>
    </div>

    <div class="flex items-center gap-[15px] pb-[15px] border-b-1 border-[#EFEFEF]">
      <img v-if="showConsumer && jobDetail.consumer.profile_picture" :src="jobDetail.consumer.profile_picture"
        class="w-[50px] h-[50px] rounded-full object-cover flex-shrink-0" alt="">
      <img v-else-if="!showConsumer && jobDetail.depp_schedule?.company_logo"
        :src="jobDetail.depp_schedule.company_logo"
        class="w-[50px] h-[50px] rounded-full object-contain flex-shrink-0 bg-white border-1 border-[#EFEFEF]" alt="">
      <span v-else class="w-[50px] h-[50px] rounded-full flex items-center justify-center flex-shrink-0 bg-[#EFEFEF]">
        <svg width="30" height="30" viewBox="0 0 16 16" aria-hidden="true">
          <path fill="#CCCCCC" d="M8 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm-5 6a5 5 0 0 1 10 0z" />
        </svg>
      </span>
      <span class="text-[16px] largeDesktop:text-[18px] text-[#333333] break-words">{{ jobDetail.consumer.full_name
      }}</span>
    </div>

    <div v-if="showConsumer" class="flex flex-wrap items-center gap-[10px] pt-[15px]">
      <!-- real <a href> (open in new tab); a plain click goes through viewMembers (closes the mobile modal first) -->
      <router-link v-slot="{ href }" :to="membersRoute" custom>
        <a :href="href"
          class="group flex items-center gap-[6px] h-[36px] px-[15px] rounded-full border-1 border-[#00B7C2] bg-[#fff] text-[14px] text-[#00B7C2] no-underline hover:!bg-[#00B7C2] hover:text-white [@media(max-width:1023px)]:!bg-[#00B7C2] [@media(max-width:1023px)]:!text-white transition"
          @click="onMembersClick">
          View Members
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" aria-hidden="true">
            <path d="M4 12h16m0 0-6-6m6 6-6 6" class="stroke-[#00B7C2] group-hover:stroke-white [@media(max-width:1023px)]:!stroke-white" stroke="currentColor"
              stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
        </a>
      </router-link>
      <!-- Call / Chat / SMS (Chat & SMS follow Android JobLandingFragment chatId rules) -->
      <ChatChooser :size="36" :show-chat="canChat" :phone="jobDetail.consumer.phone || ''" :booking-id="jobDetail.id"
        :company-consumer-id="jobDetail.company_consumer_id || 0" :consumer-name="jobDetail.consumer.full_name || ''" />

    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { Modal } from "bootstrap";
import { isNewTabClick } from "@/helpers/newTabClick";
import ChatChooser from "../chat/ChatChooser.vue";

export default {
  components: { ChatChooser },
  computed: {
    // partner jobs may show the resident (company) instead of the consumer
    showConsumer() {
      return this.jobDetail.is_partner_job == '0' || !this.jobDetail.depp_schedule?.show_consumer_as_resident;
    },
    // Android JobLandingFragment: no chat for these statuses
    canChat() {
      const status = (this.jobDetail.status_text || '').toLowerCase();
      return !['completed', 'cancelled', 'rejected by technician', 'pending', 'new system', 'consumer quote decline'].includes(status);
    },
    membersRoute() {
      return { name: 'job-members', params: { id: this.jobDetail.id || this.$route.params.id } };
    },
    ...mapGetters(["jobDetail"]),
  },

  methods: {
    // Figma "Members & Contacts" is a full page now; on mobile this card sits inside job-detail's #profileModal,
    // so close that first (else its backdrop stays behind after the route change)
    onMembersClick(e) {
      if (isNewTabClick(e)) return; // browser opens it in a new tab
      e.preventDefault();
      this.viewMembers();
    },
    viewMembers() {
      const go = () => this.$router.push(this.membersRoute);
      const modalEl = this.$el?.closest?.('.modal.show');
      if (!modalEl) return go();
      modalEl.addEventListener('hidden.bs.modal', go, { once: true });
      Modal.getOrCreateInstance(modalEl).hide();
    },
  },
};
</script>

<style>
.consumerDetail .profilePic {
  width: 120px;
  height: 120px;
  border-radius: 50%;
  object-fit: cover;
}
</style>
